import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

import { observer } from "mobx-react-lite";
import { NoEventStats } from "../../data/models/stats";
import { capitalizeFirstLetter } from "../../utils/utils";
import { useTranslation } from "react-i18next";


interface NumberOfClientsProps {
    numberOfClients: number | undefined;
    title: string;
}

function NumberOfClientsStats({ numberOfClients, title }: NumberOfClientsProps) {
    const { t } = useTranslation();
    return (
        <TableContainer component={Paper} sx={{ bgcolor: "#fff" }}>
            
            <Table sx={{ minWidth: 650 }} aria-label="caption table">
                <TableHead>
                    <TableRow>
                    <TableCell sx={{ textAlign: "left" }}><Box sx={{ p: 1 }}>
                        <Typography component={"h2"} variant="h6">{title} </Typography>
                        </Box></TableCell>
                        
                        <TableCell sx={{ textAlign: "center" }}>{numberOfClients}</TableCell>
                    </TableRow>
                </TableHead>
            </Table>
        </TableContainer>
    );
}

export default observer(NumberOfClientsStats);